import { useViewportContext } from '../context';
/**
 * Get information about the current UI state of the application.
 */
export const useGuidaUIStates = () => {
    const viewPortSettings = useViewportContext();
    return viewPortSettings;
};
//# sourceMappingURL=useGuidaUIStates.js.map